import React from "react";
import { Palette, Wallet, Eye, Clock, UserCheck } from "lucide-react";

function WhyChooseUs() {
  const items = [
    {
      title: "Custom Designs",
      desc: "We create unique interiors, no templates used.",
      icon: Palette,
    },
    {
      title: "Budget-Friendly Plans",
      desc: "Flexible pricing for every type of project.",
      icon: Wallet,
    },
    {
      title: "3D Realistic Preview",
      desc: "See your space before execution with high-quality visuals.",
      icon: Eye,
    },
    {
      title: "On-Time Delivery",
      desc: "We ensure every project is completed within deadline.",
      icon: Clock,
    },

  ];

  return (
    <section className="relative py-16 px-6 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505]">

      {/* BACKGROUND EFFECTS */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-orange-500/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* GRID */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:70px_70px]" />

      <div className="relative z-10 max-w-7xl mx-auto">


       <div className="text-center mb-12 md:mb-16">
                  <h2 className="myheading text-3xl md:text-5xl text-center">
                  Why Choose Us for {" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
           Interior Design 
            </span>
          </h2>
   <p className="myparagraph text-gray-500">
  We deliver quality, creativity, and trust in every project
          </p>
      </div>
   

        {/* GRID */}
        <div className="grid md:grid-cols-4 gap-4">

          {items.map((item, index) => {
            const Icon = item.icon;

            return (
              <div
                key={index}
                className="p-7 rounded-2xl border border-gray-200 dark:border-white/10 bg-white/80 dark:bg-white/5 backdrop-blur-md hover:scale-[1.03] transition"
              >

                {/* ICON */}
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-orange-500/10 text-primary mb-4">
                  <Icon size={22} />
                </div>

                {/* TITLE */}
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  {item.title}
                </h3>

                {/* DESC */}
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                  {item.desc}
                </p>

              </div>
            );
          })}

        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;